import React from 'react';
import { Field, FieldArray, ErrorMessage, useFormikContext } from 'formik';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Trash } from 'react-bootstrap-icons';
import PropTypes from 'prop-types';
import { generateWorkerTimesheetFrontendId } from '../../clients/worker_timesheet_client';

/**
 * Dynamic expense rows: description, amount, optional receipt file.
 * `receipt` is a `File` or null; uploads use S3 presigned POSTs matched by `frontend_id`.
 *
 * @param {Object} props
 * @param {string} [props.name] - FieldArray name (default `expenses`)
 * @returns {JSX.Element}
 */
const ExpensesSection = ({ name = 'expenses' }) => {
  const { setFieldValue, values } = useFormikContext();
  const list = values[name] || [];

  return (
    <div className="worker-ts-expenses">
      <h5 className="mb-3">הוצאות</h5>
      <FieldArray name={name}>
        {({ push, remove }) => (
          <>
            {list.map((row, i) => (
              <div key={row.frontend_id || i} className="mb-3">
                <div className="d-flex d-md-none justify-content-between align-items-center mb-2">
                  <span className="text-muted small">הוצאה {i + 1}</span>
                  <Button
                    type="button"
                    variant="outline-danger"
                    size="sm"
                    title="הסר הוצאה"
                    onClick={() => remove(i)}
                    aria-label="הסר הוצאה"
                  >
                    <Trash size={18} />
                  </Button>
                </div>
                <Row className="g-2 align-items-end">
                <Col md={4} xs={12}>
                  <Form.Label>תיאור *</Form.Label>
                  <Field
                    as={Form.Control}
                    name={`${name}.${i}.description`}
                    placeholder="לדוגמה: חניה"
                  />
                  <ErrorMessage
                    name={`${name}.${i}.description`}
                    component="div"
                    className="text-danger small"
                  />
                </Col>
                <Col md={3} xs={12}>
                  <Form.Label>סכום *</Form.Label>
                  <Field
                    as={Form.Control}
                    name={`${name}.${i}.amount`}
                    type="number"
                    min={0}
                    step="0.01"
                    inputMode="decimal"
                    placeholder="0.00"
                  />
                  <ErrorMessage
                    name={`${name}.${i}.amount`}
                    component="div"
                    className="text-danger small"
                  />
                </Col>
                <Col md={4} xs={12}>
                  <Form.Label>קבלה (אופציונלי)</Form.Label>
                  <Form.Control
                    type="file"
                    name={`${name}.${i}.receipt`}
                    onChange={e => {
                      const f = e.target.files?.[0] || null;
                      setFieldValue(`${name}.${i}.receipt`, f);
                    }}
                  />
                  {row.receipt instanceof File && (
                    <div className="small text-muted mt-1">
                      נבחר: {row.receipt.name}
                    </div>
                  )}
                </Col>
                <Col
                  md={1}
                  xs={12}
                  className="d-none d-md-flex justify-content-end align-items-end"
                >
                  <Button
                    type="button"
                    variant="outline-danger"
                    size="sm"
                    title="הסר הוצאה"
                    onClick={() => remove(i)}
                    aria-label="הסר הוצאה"
                  >
                    <Trash size={18} />
                  </Button>
                </Col>
              </Row>
              </div>
            ))}
            <div className="d-grid d-sm-inline-block">
            <Button
              type="button"
              variant="outline-primary"
              size="sm"
              className="py-2"
              onClick={() =>
                push({
                  description: '',
                  amount: '',
                  receipt: null,
                  frontend_id: generateWorkerTimesheetFrontendId(),
                })
              }
            >
              הוסף הוצאה
            </Button>
            </div>
          </>
        )}
      </FieldArray>
    </div>
  );
};

ExpensesSection.propTypes = {
  name: PropTypes.string,
};

export default ExpensesSection;
